/* Versand-Balken / free shipping progress bar (2026-11-03)
   Keeps every [data-fsb] element in sync with the cart without a page reload.
   2026-11-03: also updates the "Gratis-Sticker" tier ([data-fsb-gift]) and fires
   the document event "fsb:rendered" (detail.cart) for assets/cart-boosters.js. */
(function () {
  if (window.__fsbInit) return;
  window.__fsbInit = true;

  var lastCart = null;
  var timer = null;
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  function rate() {
    var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return r > 0 ? r : 1;
  }
  function shopFormat(cents, fmt) {
    var m = fmt && fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) return null;
    function d(n, p, t, dec) {
      var parts = (n / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t) + (parts[1] ? dec + parts[1] : '');
    }
    var v;
    switch (m[1]) {
      case 'amount': v = d(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': v = d(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = d(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = d(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = d(cents, 2, "'", '.'); break;
      default: return null;
    }
    return fmt.replace(m[0], v);
  }
  function formatMoney(cents, currency, el) {
    if (el && currency === el.getAttribute('data-fsb-shop-currency')) {
      var s = shopFormat(cents, el.getAttribute('data-fsb-money-format'));
      if (s) return s;
    }
    var locale = document.documentElement.lang || 'de';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function render(cart) {
    if (!cart) return;
    lastCart = cart;
    var els = document.querySelectorAll('[data-fsb]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var base = parseInt(el.getAttribute('data-fsb-threshold'), 10) || 0;
      if (!base) continue;
      var shopCur = el.getAttribute('data-fsb-shop-currency');
      var cur = cart.currency || shopCur;
      var threshold = cur === shopCur ? base : Math.round(base * rate());
      var total = cart.total_price || 0;
      var remaining = threshold - total;
      var pct = Math.max(0, Math.min(100, (total / threshold) * 100));

      if (!cart.item_count) {
        el.hidden = true;
        continue;
      }
      var msg = remaining > 0
        ? (el.getAttribute('data-fsb-text-remaining') || '').replace('[[amount]]', formatMoney(remaining, cur, el))
        : el.getAttribute('data-fsb-text-success') || '';
      var textEl = el.querySelector('[data-fsb-text]');
      if (textEl && textEl.textContent !== msg) textEl.textContent = msg;
      var prog = el.querySelector('[data-fsb-progress]');
      if (prog) prog.setAttribute('aria-valuenow', String(Math.round(pct)));
      var fill = el.querySelector('[data-fsb-fill]');
      if (fill) fill.style.width = pct + '%';
      el.classList.toggle('fsb--success', remaining <= 0);
      el.hidden = false;
      renderGift(el, cart, cur, shopCur);
    }
    try {
      document.dispatchEvent(new CustomEvent('fsb:rendered', { detail: { cart: cart } }));
    } catch (e) {}
  }

  function giftState(giftEl, cart) {
    var variant = parseInt(giftEl.getAttribute('data-gift-variant'), 10) || 0;
    var threshold = parseInt(giftEl.getAttribute('data-gift-threshold'), 10) || 0;
    var giftTotal = 0;
    var giftQty = 0;
    var giftKey = null;
    (cart.items || []).forEach(function (item) {
      if (variant && item.variant_id === variant) {
        giftTotal += item.final_line_price || 0;
        giftQty += item.quantity || 0;
        giftKey = item.key;
      }
    });
    var subtotal = (cart.total_price || 0) - giftTotal;
    return {
      variant: variant,
      threshold: threshold,
      subtotal: subtotal,
      remaining: threshold - subtotal,
      qty: giftQty,
      key: giftKey
    };
  }
  window.FreeShippingBar_giftState = giftState;

  function renderGift(el, cart, cur, shopCur) {
    var giftEl = el.querySelector('[data-fsb-gift]');
    if (!giftEl) return;
    if (cur !== shopCur) {
      giftEl.hidden = true;
      return;
    }
    var st = giftState(giftEl, cart);
    if (!st.threshold) return;
    var msg;
    if (st.remaining > 0) {
      msg = (giftEl.getAttribute('data-gift-text-remaining') || '').replace('[[amount]]', formatMoney(st.remaining, cur, el));
    } else if (st.qty > 0) {
      msg = giftEl.getAttribute('data-gift-text-in-cart') || '';
    } else {
      msg = giftEl.getAttribute('data-gift-text-reached') || '';
    }
    var t = giftEl.querySelector('[data-fsb-gift-text]');
    if (t && t.textContent !== msg) t.textContent = msg;
    var btn = giftEl.querySelector('[data-fsb-gift-add]');
    if (btn) btn.hidden = !(st.remaining <= 0 && st.qty === 0);
    giftEl.classList.toggle('fsb__gift--reached', st.remaining <= 0);
    giftEl.hidden = false;
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      _fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render)
        .catch(function () {});
    }, 150);
  }
  window.FreeShippingBar = { refresh: refresh, render: render };

  // 1) Watch fetch() calls to the cart API.
  var _fetch = window.fetch.bind(window);
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = _fetch.apply(window, arguments);
    if (CART_RE.test(url)) p.then(refresh, function () {});
    return p;
  };

  // 2) Watch XMLHttpRequest (jQuery / apps).
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_RE.test(String(url || ''))) {
      this.addEventListener('loadend', refresh);
    }
    return _open.apply(this, arguments);
  };

  // 3) Theme / app events.
  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (name) {
    document.addEventListener(name, refresh);
  });

  function boot() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
      }
    } catch (e) {}

    // 4) Re-apply state when the theme re-renders a section containing a bar.
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        if (!lastCart) return;
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType === 1 && (n.hasAttribute('data-fsb') || n.querySelector('[data-fsb]'))) {
              render(lastCart);
              return;
            }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    if (document.querySelector('[data-fsb]')) refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
